import { Award, Headphones, Network, Server } from "lucide-react";
import LegalPage from "@/pages/legal/LegalPage";

const services = [
  { icon: Network, title: "Altyapıdan İnternet", desc: "Aynı altyapıdan hizmete daha uygun fiyata taahhütsüz ve kotasız internet." },
  { icon: Server, title: "Kurumsal Çözümler", desc: "İşletmelere özel yüksek performanslı AIR Fiber internet ve altyapı çözümleri." },
  { icon: Headphones, title: "Çağrı Merkezi", desc: "Müşterilerimize mesai saatleri içinde hizmet veren yerel destek ekibimiz." },
  { icon: Award, title: "Teknik Servis", desc: "Sahada ve dijitalde hızlı çözümler üreten teknik ekibimiz." },
];

export default function AboutUs() {
  return (
    <LegalPage title="Hakkımızda" testId="legal-about">
      <div className="rounded-2xl border border-zinc-200 bg-[#F0FDFA] p-7">
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2DD4BF]">ÇAĞRINETWORK İNTERNET İLETİŞİM HABERLEŞME LTD ŞTİ</p>
        <p className="mt-4 text-[15px] leading-relaxed text-gray-600">
          Muğla'nın Ortaca ilçesinde kurulan ÇağrıNET, bölgesine yüksek hızlı ve güvenilir internet
          erişimi sunmayı amaç edinmiş bir internet servis sağlayıcısıdır. Altyapı İşletmeciliği ve
          İnternet Servis Sağlayıcılığı ile yetkilendirilmiş lisanslı firma olarak, bölgemizdeki her
          haneye ve işletmeye büyük şehir kalitesinde AIR Fiber internet hizmeti ulaştırmayı hedefliyoruz.
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-gray-600">
          Kurulduğumuz günden bu yana, büyük operatörlerin yeterince yatırım yapmadığı bölgelere
          modern AIR Fiber altyapı taşıyor; yerel bir şirket olmanın gücüyle abonelerimize komşumuz gibi
          davranıyoruz. Teknik ekibimiz aynı gün müdahale, mesai saatleri içinde destek ve şeffaf fiyatlandırma
          ilkeleriyle çalışır.
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-gray-600">
          ÇağrıNET tarafından yürütülen tüm hizmetler, Bilgi Teknolojileri ve İletişim Kurumu (BTK)
          tarafından denetlenmektedir.
        </p>
      </div>

      <h2 className="font-display text-xl font-bold text-[#062B2B]">Hizmetlerimiz</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {services.map((s) => (
          <div key={s.title} className="rounded-xl border border-zinc-200 bg-white p-6">
            <s.icon className="h-7 w-7 text-[#2DD4BF]" />
            <h3 className="mt-3 font-display text-base font-bold text-[#062B2B]">{s.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-gray-500">{s.desc}</p>
          </div>
        ))}
      </div>

      <div className="rounded-2xl bg-gradient-to-br from-[#062B2B] via-[#0A3D3D] to-[#0F766E] p-7 text-white">
        <h3 className="font-display text-lg font-bold">Misyonumuz</h3>
        <p className="mt-2 text-sm leading-relaxed text-zinc-300">
          Bölgemizdeki her haneye ve işletmeye, hızlı, kesintisiz ve uygun fiyatlı internet erişimi sağlamak.
        </p>
        <h3 className="mt-5 font-display text-lg font-bold">Vizyonumuz</h3>
        <p className="mt-2 text-sm leading-relaxed text-zinc-300">
          Muğla ve çevresinin dijital dönüşümüne öncülük eden, en güvenilir bölgesel telekomünikasyon şirketi olmak.
        </p>
      </div>
    </LegalPage>
  );
}
